document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.querySelector('[data-mokotracker-sticky-bar]');
  const footer = document.querySelector('.footer');
  const form = document.querySelector('[data-mokotracker-sticky-form]');

  if (!stickyBar) return;

  let footerVisible = false;

  const updateBarVisibility = () => {
    if (!footerVisible) {
      stickyBar.classList.remove('translate-y-full');
      stickyBar.classList.add('translate-y-0');
    } else {
      stickyBar.classList.add('translate-y-full');
      stickyBar.classList.remove('translate-y-0');
    }
  };

  updateBarVisibility();

  if (footer) {
    const footerObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          footerVisible = entry.isIntersecting;
          updateBarVisibility();
        }
      },
      { threshold: 0 }
    );

    footerObserver.observe(footer);
  }

  if (!form) return;

  const submitButton = form.querySelector('[data-sticky-atc-button]');
  const buttonText = submitButton?.querySelector('[data-button-text]');
  const buttonLoader = submitButton?.querySelector('[data-button-loader]');

  const setLoading = (isLoading) => {
    if (!submitButton) return;
    submitButton.disabled = isLoading;
    buttonText?.classList.toggle('invisible', isLoading);
    buttonLoader?.classList.toggle('hidden', !isLoading);
    buttonLoader?.classList.toggle('flex', isLoading);
  };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (submitButton?.disabled) return;

    setLoading(true);

    const formData = new FormData(form);
    const sectionId = document.querySelector('cart-drawer')?.dataset?.sectionId;
    const sections = sectionId ? [sectionId] : [];

    if (typeof CartAPI === 'undefined') {
      form.submit();
      return;
    }

    try {
      const data = await CartAPI.add(formData, sections);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartAdd, {
          source: 'mokotracker-sticky-bar',
          productId: form.closest('[data-mokotracker-sticky-bar]')?.dataset?.productId,
          sections: data.sections,
          items: data.items,
          item_count: data.item_count,
        });
      }
    } catch (error) {
      const message = error?.description ?? error?.message ?? 'Something went wrong.';
      const cartDrawer = document.querySelector('cart-drawer');
      cartDrawer?.showToast?.(message);
    } finally {
      setLoading(false);
    }
  });
});
